import React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { trackSubNavEvent } from "../../../analytics";
var useStyles = makeStyles(function () {
    return createStyles({
        items: {
            position: "absolute",
            top: 68,
            left: -16,
            padding: "8px 0",
            backgroundColor: "#fff",
            borderRadius: "8px",
            border: "solid 1px #d8d8d8",
            boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.2)",
        },
        list: {
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontSize: 0,
            color: "#010414",
            cursor: "pointer",
            userSelect: "none",
        },
        link: {
            display: "inline-block",
            width: "100%",
            padding: "8px 16px",
            fontSize: "16px",
            lineHeight: "22px",
            letterSpacing: 0.4,
            "&:hover": {
                fontWeight: "bold",
                letterSpacing: "normal",
                textShadow: "0 0 #fff",
                WebkitFontSmoothing: "subpixel-antialiased",
            },
            "&::before": {
                display: "block",
                content: "attr(data-title)",
                visibility: "hidden",
                overflow: "hidden",
                height: 0,
                fontWeight: "bold",
                letterSpacing: 0.4,
            },
        },
    });
});
var Subcategories = function (_a) {
    var subcategories = _a.subcategories;
    var styles = useStyles();
    return (React.createElement("ul", { className: styles.items }, subcategories.map(function (_a, index) {
        var name = _a.name, url = _a.url;
        return (React.createElement("li", { key: index, className: styles.list },
            React.createElement("a", { href: url, className: styles.link, id: "header" + name.replace(/\s*\W*/g, ""), onClick: function () { return trackSubNavEvent(name, url); }, "data-title": name }, name)));
    })));
};
export default Subcategories;
